export const DECLARED_FIELDS_NAMES = ['streetName', 'streetNumber', 'city', 'province', 'country', 'postalCode'];
